import axios, { AxiosPromise } from "axios";
import axiosRetry from "axios-retry";

const headers: any = { "Content-Type": "application/json;charset=utf-8" };
if (process.env.VUE_APP_TOKEN) {
  headers["x-imonit-token"] = process.env.VUE_APP_TOKEN;
}
const query = new URLSearchParams(window.location.search);
let path = "";
if (query.get("useUS")) {
  path = "/us";
} else {
  const territory = query.get("territory");
  if (territory?.length) {
    path = `/${territory}`;
  }
}
const baseUrl = `${path}${process.env.VUE_APP_BASE_URL}`;

const service = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
  responseType: "json",
  withCredentials: true,
  headers
});

axiosRetry(service, { retries: 1 });

export class HttpClient {
  public static setCSRFToken(token: string) {
    service.interceptors.request.use(request => {
      request.headers["x-csrf-token"] = token;
      return request;
    });
  }

  public static get<T>(
    url: string,
    option?: {
      authorization?: string;
    }
  ): AxiosPromise<T> {
    let headers: any;
    if (option && option.authorization && option.authorization.length) {
      headers = {
        Authorization: option.authorization
      };
    }

    return service.get<T>(url, headers ? { headers } : {});
  }

  public static post<T>(url: string, payload: any): AxiosPromise<T> {
    return service.post<T>(url, payload);
  }

  public static delete<T>(url: string): AxiosPromise<T> {
    return service.delete(url);
  }

  public static patch<T>(url: string, payload: any): AxiosPromise<T> {
    return service.patch<T>(url, payload);
  }
}
